import _regeneratorRuntime from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/@babel/runtime-corejs2/helpers/esm/regeneratorRuntime.js";
import "core-js/modules/es6.regexp.replace";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/@babel/runtime-corejs2/helpers/esm/objectSpread2.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex';
import Breadcrumb from '@/components/Breadcrumb';
import Hamburger from '@/components/Hamburger';
import downloadCenter from '@/views/downLoadCenter/downLoadCenterList';
import ArtilleryFirelist from '@/views/downLoadCenter/artilleryFirelist.vue';
export default {
  components: {
    ArtilleryFirelist: ArtilleryFirelist,
    Breadcrumb: Breadcrumb,
    Hamburger: Hamburger,
    downloadCenter: downloadCenter
  },
  data: function data() {
    return {
      showDropdown: false,
      drawer: false,
      drawerFire: false
    };
  },
  computed: _objectSpread({}, mapGetters(['sidebar', 'avatar', 'userInfo', 'head', 'serviceName'])),
  watch: {
    userInfo: {
      immediate: true,
      handler: function handler(val, oldVal) {
        var _this = this;
        if (val.nick_name) {
          this.$watermark.content = val.nick_name;
          setTimeout(function () {
            _this.$watermark.create();
          }, 500);
        }
      }
    }
  },
  methods: {
    openLiyue: function openLiyue() {
      window.open(this.head.shop);
    },
    openFenx: function openFenx() {
      window.open(this.head.funshare);
    },
    openBeis: function openBeis() {
      window.open(this.head.iTalent);
    },
    toggleDropdown: function toggleDropdown(visible) {
      this.showDropdown = visible;
    },
    toggleSideBar: function toggleSideBar() {
      this.$store.dispatch('app/toggleSideBar');
    },
    changePassword: function changePassword() {
      this.$router.push({
        name: 'changePassword'
      });
    },
    // 更改系统模式
    goSystem: function goSystem() {
      this.$router.push({
        name: 'changeSystem'
      });
    },
    // 烽火雷达
    artilleryRadar: function artilleryRadar() {
      this.drawerFire = true;
    },
    logout: function logout() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this2.$store.dispatch('user/logout');
            case 2:
              _this2.$router.replace({
                path: '/login'
              });
              // window.location.href = '#/login'
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    // 下载中心
    goDown: function goDown() {
      this.drawer = true;
      // let src = window.location.origin
      // console.log(window.location.origin)
      // // let src = ''
      // if (process.env.VUE_APP_NAME === 'production') {
      //   src = `${src}/#/downLoadCenter/downLoadCenter`
      // } else if (process.env.VUE_APP_NAME === 'test') {
      //   src = `${src}/#/downLoadCenter/downLoadCenter`
      // } else {
      //   src = `${src}/#/downLoadCenter/downLoadCenter`
      // }
      // window.open(src, '_blank')
      // // this.$router.push({
      // //   name: 'downLoadCenter'
      // // })
    },
    uploadAvatar: function uploadAvatar() {
      this.$router.push({
        name: 'uploadAvatar'
      });
    }
  }
};